import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, Scroll } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { fromEvent, Subscription, Observable } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { DocumentComponent } from 'src/app/document/document-models/documentComponent';
import { DocumentService } from 'src/services/document.service';
import { DetectMobileView } from 'src/utils/detect-mobile-view';
import { DocumentItem } from '../document-models/document-item';
import { ReplaySubject } from 'rxjs';
import { DocumentSectionElement } from '../document-models/document-section-element';
import { ScrollToSection } from 'src/app/actions/document-list.actions';
import { SearchService } from 'src/app/search/search.service';
import { Action } from '@ngrx/store';

/*
  IMPORTANT: Monographs use the OnPush Change detection strategy. This makes angular only
  check for changes when the htmlElement OBJECT itself is changed or
  changeDetectionRef.detectChanges() is called

  This applies to all child elements as well, so the table of contents and
  tool bar search needs to call changeDetectionRef.detectChanges() after initialization
  or clear search
*/
@Component({
  selector: 'app-cps-monograph-document',
  templateUrl: './cps-monograph-document.component.html',
  styleUrls: ['./cps-monograph-document.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CpsMonographDocumentComponent implements OnInit, DocumentComponent, OnDestroy {
  @Input() htmlElement: HTMLElement;
  @ViewChild('docWrapper') documentWrapperElement: ElementRef;
  public doc: DocumentItem;

  public displayHTML: HTMLElement;

  public scrollPosition: number;

  public isManufacturerModalInitialized: boolean;
  public contentLoaded = false;
  mobileView = false;
  isBucketExpandedMobile: boolean;

  private showBuckets: Subscription;

  public monographSections: Array<DocumentSectionElement>;

  private destroy$: ReplaySubject<boolean> = new ReplaySubject<boolean>();

  public emptyTOC = false;

constructor(public translationService: TranslateService,
   private documentService: DocumentService,
   private searchService: SearchService,
   private changeDetector: ChangeDetectorRef) {
   this.mobileView = DetectMobileView.detectScreenSize();
    this.monographSections = new Array<DocumentSectionElement>();
    
    fromEvent(window, 'resize').pipe(debounceTime(75)).pipe(takeUntil(this.destroy$)).subscribe(event => {
      this.mobileView = DetectMobileView.detectScreenSize();
      this.isBucketExpandedMobile = !this.mobileView;
    });
  }
  
  ngOnInit(): void {
    this.checkContentLoaded();

    this.showBuckets = this.searchService.getIsBucketExpandedMobile()
      .pipe(takeUntil(this.destroy$)).subscribe(isBucketExpandedMobile => {
        this.isBucketExpandedMobile = isBucketExpandedMobile;
        this.changeDetector.detectChanges();
      });
  }

  checkContentLoaded(): void {
    const thizz = this;
    this.documentService.getContentLoaded().pipe(takeUntil(this.destroy$)).subscribe(isLoaded => {
      thizz.contentLoaded = isLoaded;
      thizz.changeDetector.detectChanges();
    });
  }
  
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
    this.showBuckets.unsubscribe();
  }
}
